import React, { useState, useEffect, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  fakeWorkNumModifyStateRecoil,
} from '../../atom/ModalAtom';
import { userIdState } from '../../atom/TokenAtom';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface FakeWorkNumsProps {
  onListUpdate: () => void;
}

const FakeWorkNumModiFy = ({ onListUpdate }: FakeWorkNumsProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(fakeWorkNumModifyStateRecoil);

  const [selectDate, setSelectDate] = useState<string>('');
  const [fakeWorkNumId, setFakeWorkNumId] = useState<number>(0);
  const [fakeWorkNum, setFakeWorkNum] = useState<number>(0);
  const [modifyFakeWorkNum, setModifyFakeWorkNum] = useState<number | null>(
    null,
  );
  const [fakeWorkNumNone, setFakeWorkNumNone] = useState<boolean>(false);

  const getFakeWrokNum = async (date: string) => {
    try {
      const response = await roomAPI.getFakeWorkNums();
      const selectFakeWorkNum = response.data.find(
        (item) =>
          item.year === Number(date.split('-')[0]) &&
          item.month === Number(date.split('-')[1]),
      );
      if (selectFakeWorkNum) {
        setFakeWorkNumId(selectFakeWorkNum.id);
        setFakeWorkNum(selectFakeWorkNum.addition);
      } else {
        setError('선택하신 날짜는 존재하지 않습니다.');
        setFakeWorkNumNone(true);
        setFakeWorkNum(0);
      }
    } catch {}
  };

  const onChangeModifyDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFakeWorkNumNone(false);
    setSelectDate(e.target.value);
    getFakeWrokNum(e.target.value);
  };

  const handleConfirm = async () => {
    if (fakeWorkNumNone) {
      setError('선택하신 날짜는 존재하지 않습니다.');
      return;
    }

    if (modifyFakeWorkNum === null) {
      setError(blankMsg);
      return;
    }

    try {
      await roomAPI.putFakeWorkNum(fakeWorkNumId, modifyFakeWorkNum);
      setModalState(false);
      onListUpdate();
      setConfirm('성공적으로 수정되었습니다.');
    } catch {
      setError('가 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    setSelectDate(formattedDate);
    getFakeWrokNum(formattedDate);
  }, []);

  return (
    <>
      <InputModal
        title="가 수정"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>수정 날짜</h2>
            <CS.TextInputType1
              type="month"
              value={selectDate}
              onChange={onChangeModifyDate}
            />
          </li>
          <li>
            <h2>현재 가탕</h2>
            <CS.TextInputType1
              placeholder="0"
              type="text"
              disabled={true}
              value={fakeWorkNum.toLocaleString()}
              onChange={(e) => setFakeWorkNum(e.target.valueAsNumber)}
            />
          </li>
          <li>
            <h2>
              수정 가탕
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="수정 가탕 입력"
              type="text"
              value={
                modifyFakeWorkNum !== null
                  ? modifyFakeWorkNum.toLocaleString()
                  : ''
              }
              disabled={fakeWorkNumNone}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/[^0-9]/g, '')
                  .replace(/,/g, '');
                setModifyFakeWorkNum(value === '' ? null : Number(value));
              }}
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default FakeWorkNumModiFy;
